<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <!-- <c-form-item type="input" label="经销商账号" name="user_name"></c-form-item> -->
                    <c-form-item type="input" label="经销商名称" name="company_name"></c-form-item>
                    <c-form-item type="input" label="店铺名称" name="shop_name"></c-form-item>
                    <c-form-item type="select" label="经销商角色" name="auth_id" options="SELLER_AUTH"></c-form-item>
                    <c-form-item type="checkbox" label="经销商状态" name="state" :options="stateType"></c-form-item>
                    <c-form-item type="checkbox" label="账号状态" name="account_state" :options="accountStateType"></c-form-item>
                </c-form>
            </m-search>
			
            <m-operate>
              <c-button power="b_seller_stationed_user_edit" color="sys" @click="createStationed">新增经销商</c-button>
            </m-operate>
            <c-table ref="table" >
                <c-table-column  label="经销商名称" name="company_name"  width="200">
                </c-table-column>
				
				<c-table-column
					label="所属平台会员"
					name="platform_user_id"
					width="240"
					v-if="systemConfig.oms_seller_shop_enabled == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.platform_user_id == 0" style="color:#999">无</span>
						<a v-else class="s-link" style="text-decoration: underline;" @click="navigateTo(`/member/${data.platform_user_id}`)">
							<span>{{data.platform_user_mobilephone}}</span>
							<span v-if="data.platform_nick_name && data.platform_nick_name!=''">({{data.platform_nick_name}})</span>
						</a>
					</template>
				</c-table-column>
				
                <c-table-column label="经销商角色"  name="auth_name" width="100">
                </c-table-column>
                <c-table-column label="服务费比例" name="platform_profit_model" width="90">
                  <template v-slot="{data}">
                    <a class="s-link" @click="setProfit(data)">{{data.service_fee_ratio}}%</a>
                  </template>
                </c-table-column>
				
				<c-table-column label="保证金额度" name="deposit_money" width="100">
				  <template v-slot="{data}" >
				    <span v-if="data.deposit_money > 0" ><a class="s-link" @click="setDeposit(data)">￥{{data.deposit_money}}</a></span>
				    <span v-else style="color:#999999"><a @click="setDeposit(data)">去设置</a></span>
				  </template>
				</c-table-column>
				
                <c-table-column label="店铺名称"  name="shop_name" width="180">
                  <template v-slot="{data}">
                    <span v-if="data.is_open_shop == 1">--</span>
                    <span v-if="data.is_open_shop == 2">{{data.shop_name}}</span>
                  </template>
                </c-table-column>
				
                <c-table-column label="发货地址" name="state" width="150">
                    <template v-slot="{data}">
                    {{data.delivery_province_name}} {{data.delivery_city_name}}
                    </template>
                </c-table-column>

                <c-table-column label="经销商状态" name="state" width="90">
                    <template v-slot="{data}">
                      <span v-if="data.state == 1" style="color:red">停用</span>
                      <span v-if="data.state == 2" style="color:green">启用</span>
                    </template>
                </c-table-column>

                <c-table-column label="主账号/状态" name="account_state" width="140">
                  <template v-slot="{data}">
                    {{data.user_name}}
                    <span v-if="data.account_state == 1" style="color:red">禁用</span>
                    <span v-if="data.account_state == 2" style="color:green">启用</span>
                  </template>
                </c-table-column>

                <c-table-column  type="button" fixed="right" label="操作"  width="180">
                    <template v-slot="{data}">
						<c-table-button @click="view(data)">查看</c-table-button>
						<c-table-button power="b_seller_stationed_user_edit" @click="edit(data)">编辑</c-table-button>
                        <c-table-button power="b_seller_stationed_user_edit" v-if="data.state == 2" @click="updateState(1,data)">停用经销商</c-table-button>
                        <c-table-button power="b_seller_stationed_user_edit" v-if="data.state == 1" @click="updateState(2,data)">启用经销商</c-table-button>
                        <c-table-button power="b_seller_stationed_user_edit" v-if="data.account_state == 2" @click="updateAccountState(1,data)">禁用账号</c-table-button>
                        <c-table-button power="b_seller_stationed_user_edit" v-if="data.account_state == 1" @click="updateAccountState(2,data)">启用账号</c-table-button>
                        <c-table-button power="b_seller_stationed_user_profit" @click="setProfit(data)">盈利设置</c-table-button>
                        <c-table-button power="b_seller_stationed_user_account" @click="setDeposit(data)">保证金设置</c-table-button>
                        <c-table-button power="b_seller_stationed_user_resetpwd" @click="resetPwd(data)" >重置密码</c-table-button>
                        <c-table-button power="b_seller_stationed_user_account_record" @click="accountRecord(data)" >资金明细</c-table-button>
                        <c-table-button power="b_seller_stationed_user_authlogin" @click="authLogin(data)" >授权登陆</c-table-button>
                    </template>
                </c-table-column>
       </c-table>
        </module>

        <c-dialog ref="stationedEdit" :title="editState ? '编辑经销商' : '新增经销商'" width="600" @resolve="submitStationed">
          <c-form ref="stationedForm">
            <c-form title="基本信息">
              <c-form-item type="input" label="经销商名称" name="company_name" maxlength="30" required></c-form-item>
              <c-form-item type="input" label="店铺名称" name="shop_name" maxlength="50" required></c-form-item>
              <c-form-item type="hidden" name="id"></c-form-item>
			  <c-form-item type="hidden" label="商家类型" name="stationed_type" value="2"></c-form-item>
			  
			  <c-form-item type="hidden" label="店铺地址" name="address" value="待完善"></c-form-item>
			  <c-form-item type="hidden" label="主营类目" name="main_category" value="待完善"></c-form-item>
			  <c-form-item type="hidden" label="经营模式" name="management_model" value="待完善"></c-form-item>
			  <c-form-item type="hidden" label="品牌介绍" name="shop_content" value="待完善"></c-form-item>
          </c-form>
          <c-form title="配置信息">
            <c-form-item type="region" label="默认发货地" v-show="!editState" province-name="delivery_province_id" city-name="delivery_city_id"  required></c-form-item>
            <c-form-item type="select" label="经销商角色" name="auth_id" options="SELLER_AUTH" required></c-form-item>
			<c-form-item type="radio" label="清分方式" name="liquidation_type" :options="liquidationType" required></c-form-item>
			<div style="display:inline-block">
				<c-form-item type="number" label="" name="liquidation_date" :limit="[0,100]" style="float:left"></c-form-item>
				<div style="float: left; height: 38px;display: flex;align-items: center;margin-left:5px;">天</div>
			</div>
            <c-form-item type="radio" label="状态" name="state" :options="stateType" required></c-form-item>
          </c-form>
          </c-form>
        </c-dialog>
		
		<c-dialog ref="stationedView" title="经销商详情" width="800" :button="false">
		  <c-form ref="stationedFormView">
		    <c-form title="基本信息">
		      <c-form-item type="input" label="经销商名称" name="company_name" maxlength="30" required disabled></c-form-item>
		      <c-form-item type="input" label="店铺名称" name="shop_name" maxlength="50" disabled></c-form-item>
		      <c-form-item type="hidden" name="id"></c-form-item>
		  </c-form>
		  <c-form title="配置信息">
		    <c-form-item type="region" label="默认发货地" province-name="delivery_province_id" city-name="delivery_city_id"  required disabled></c-form-item>
		    <c-form-item type="select" label="经销商角色" name="auth_id" options="SELLER_AUTH" required disabled></c-form-item>
			<c-form-item type="radio" label="清分方式" name="liquidation_type" :options="liquidationType" required disabled></c-form-item>
			<div style="display:inline-block">
				<c-form-item type="number" label="" name="liquidation_date" :limit="[0,100]" style="float:left" disabled></c-form-item>
				<div style="float: left; height: 38px;display: flex;align-items: center;margin-left:5px;">天</div>
			</div>
		    <c-form-item type="radio" label="状态" name="state" :options="stateType" required disabled></c-form-item>
		  </c-form>
		  </c-form>
		</c-dialog>

      <c-dialog ref="profitEdit" title="盈利设置" width="400" @resolve="submitProfit">
        <c-form ref="profitForm">
		  <div>
				<c-form-item type="number" decimal="2" :limit="[0,99]"  label="服务费比例" name="service_fee_ratio" required style="float:left"></c-form-item>
				<div style="float: left; height: 38px;display: flex;align-items: center;margin-left:5px;">%</div>
		  </div>
          <c-form-item type="hidden" name="id"></c-form-item>
        </c-form>
      </c-dialog>

      <c-dialog ref="depositEdit" title="保证金设置" width="400" @resolve="submitDeposit">
        <c-form ref="depositForm">
          <c-form-item type="input" label="保证金金额" name="deposit_money" required></c-form-item>
          <c-form-item type="hidden" name="id"></c-form-item>
        </c-form>
      </c-dialog>

    </page>
</template>

<script>
	import {mapState} from 'vuex'
    import CryptoJs from "@/assets/script/lib/crypto-js";

    export default {
        name: 'm_seller_stationed_user',

        components: {
        },

        data() {
            return {
                stateType:[
                  {
                    name:'启用',
                    value:2
                  }, {
                      name:'停用',
                      value:1
                  }
                ],
                accountStateType:[
                  {
                    name:'启用',
                    value:2
                  }, {
                      name:'禁用',
                      value:1
                  }
                ],
				liquidationType:[
				  {
				    name:'发货后',
				    value:1
				  }, {
				      name:'确认收货后',
				      value:2
				  }
				],
                editState: true,
                platformProfitModel: 1
            }
        },
		
		computed: {
			...mapState(['systemConfig']),
		},
		
		watch: {

		},

		mounted() {
			this.$refs.search.search();
		},

        methods: {
          createStationed() {
            this.editState = false;
            this.$refs.stationedForm.clear();
			this.$refs.stationedForm.set({"address":"待完善","stationed_type":2,"main_category":"待完善","management_model":"待完善","shop_content":"待完善"});
            this.$refs.stationedEdit.open();
          },
          edit(val) {
            this.editState = true;
			this.$refs.stationedForm.clear();
            this.$refs.stationedForm.set(val);
            this.$refs.stationedEdit.open();
          },
		  view(val) {
		    this.editState = true;
			this.$refs.stationedFormView.clear();
		    this.$refs.stationedFormView.set(val);
		    this.$refs.stationedView.open();
		  },

          setProfit(val) {
            this.platformProfitModel = val.platform_profit_model;
            this.$refs.profitForm.set(val);
            this.$refs.profitEdit.open();
          },

          setDeposit(val) {
            this.$refs.depositForm.set(val);
            this.$refs.depositEdit.open();
          },

            searchHandle(data = {}) {
				data.stationed_type = 2;
                this.$refs.table.load({
                    url: '/stationed/list',
                    data
                });
            },

            detail(val) {
                this.navigateTo({
                    path: '/member/'+val.platform_user_id,
                });
            },

            updateState(type,val) {
                this.$confirm({
                    text: '确定要'+(type==2?'启用':'停用')+'【'+val.company_name+'】商家吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/stationed/update_state',
                            data: {stationed_id:val.id, state:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            updateAccountState(type,val) {
                this.$confirm({
                    text: '确定要'+(type==2?'启用':'禁用')+'商家【'+val.company_name+'】的主登陆账号吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/sys_user/update_state',
                            data: {id:val.user_id, state:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

          submitStationed(stop) {
            stop();
            this.$refs.stationedForm.submit({
              url: this.editState ? '/stationed/edit' : '/stationed/add',
              rule: {
                company_name: '请填写经销商名称',
                shop_name: '请填写店铺名称',
                delivery_city_id : '请选择发货地',
                auth_id: '请选择经销商角色',
				liquidation_type: '请选择清分方式',
				liquidation_date: '请输入清分延迟天数',
                state: '请选择状态'
              },
              dataFormatter: data => {
                data.platform_type = 2;
                return data;
              },
              success: (data, res, msg) => {
                this.$confirm({
                  icon: 'success',
                  text: msg,  // 提示内容,
                  buttonName: '确定',  // 确定按钮文字
                  cancelButton: false  // 是否显示取消按钮
                });
                this.$refs.table.update();
                this.$refs.stationedEdit.close();
              }
            });
          },
          submitDeposit(stop) {
            stop();
            this.$refs.depositForm.submit({
              url: '/stationed/account/deposit/set',
              rule: {
                deposit_money: '请填写保证金金额'
              },
              dataFormatter: data => {
                data.stationed_id = data.id;
                return data;
              },
              success: (data, res) => {
                this.$message({
                  text: '保存成功'
                });
                this.$refs.table.update();
                this.$refs.depositEdit.close();
              }
            });
          },
          submitProfit(stop) {
            stop();
            this.$refs.profitForm.submit({
              url: '/stationed/profit/set',
              rule: {
                markup_ratio: [{
                  type: 'empty',
                  word: '请填平台销售默认加价比例',
                  skip: () => {
                    return this.platformProfitModel == 1;
                  }
                }],
                service_fee_ratio: [{
                  type: 'empty',
                  word: '请填写商家服务费收取比例',
                  skip: () => {
                    return this.platformProfitModel == 2;
                  }
                }]
              },
              dataFormatter: data => {
                data.stationed_id = data.id;
                return data;
              },
              success: (data, res) => {
                this.$message({
                  text: '保存成功'
                });
                this.$refs.table.update();
                this.$refs.profitEdit.close();
              }
            });
          },
          resetPwd(val) {
            this.$confirm({
              text: '确定要重置商家【'+val.company_name+'】的密码吗？',  // 提示内容,
              buttonName: '确定',  // 确定按钮文字
              cancelButton: true,  // 是否显示取消按钮
              resolve: () => {
                this.request({
                  url: '/sys_user/reset_pwd',
                  data: {id:val.user_id},
                  loading: true,
                  success: data => {
                      this.$confirm({
                        text: data,  // 提示内容,
                        buttonName: '知道了',  // 确定按钮文字
                        cancelButton: false  // 是否显示取消按钮
                      });
                  }
                });
              },  // 确定按钮回调
              cancel: () => {},  // 取消按钮回调
            });
          },
		  accountRecord(val){
			  this.navigateTo({
			  	path: '/stationed_account_record',
			  	query: {
			  		stationed_id: val.id,
			  		company_name: val.company_name
			  	}
			  });
		  },
		  authLogin(val){
			this.request({
			    url: '/stationed/user/getAuthUrl',
			    data: {
					company_name: val.company_name,
					id: val.id
				},
			    loading: true,
			    success: data => {
			        window.open(data);
			    }
			});
		  }
        }
    }
</script>